import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-espresso text-cream pt-24 pb-12 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8 mb-24">
          
          <div className="md:col-span-4">
            <div className="font-serif text-3xl font-bold tracking-tighter uppercase flex items-center gap-3 mb-8">
              <SafeIcon name="Compass" className="text-moss-light" />
              BrewAtlas
            </div>
            <p className="text-cream-dark/60 text-base leading-relaxed mb-10 max-w-sm">
              Crafting a more intentional coffee experience through sustainable sourcing and meticulous roasting. Visit us at our Portland roastery or join our global community online.
            </p>
            <div className="flex gap-6">
              {['Instagram', 'Twitter', 'Facebook', 'Youtube'].map(icon => (
                <a key={icon} href="#" className="text-cream-dark hover:text-moss-light transition-all transform hover:-translate-y-1">
                  <SafeIcon name={icon} className="text-xl" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-bold uppercase tracking-[0.2em] text-[11px] mb-8 text-moss-light">Collections</h4>
            <ul className="space-y-4 text-sm text-cream-dark/80">
              {['Single Origins', 'Seasonal Blends', 'Espresso Roasts', 'Decaf Options', 'Limited Releases'].map(item => (
                <li key={item}><a href="#" className="hover:text-white transition-colors">{item}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-bold uppercase tracking-[0.2em] text-[11px] mb-8 text-moss-light">The Roastery</h4>
            <ul className="space-y-4 text-sm text-cream-dark/80">
              {['Our Story', 'Wholesale', 'Brew Guides', 'Shipping Info', 'Roast Schedule'].map(item => (
                <li key={item}><a href="#" className="hover:text-white transition-colors">{item}</a></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="bg-white/5 p-8 border border-white/10 rounded-sm">
              <h4 className="font-serif text-2xl font-bold mb-4">The Logbook</h4>
              <p className="text-sm text-cream-dark/60 mb-6">Receive field notes, new harvest alerts, and exclusive subscriber pricing.</p>
              <form className="flex flex-col gap-3" onSubmit={(e) => e.preventDefault()}>
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="bg-espresso/50 border border-white/20 px-4 py-3 text-sm focus:outline-none focus:border-moss transition-colors"
                />
                <button type="submit" className="bg-moss py-3 text-[10px] font-bold uppercase tracking-[0.2em] hover:bg-moss-light transition-colors cursor-pointer shadow-lg">
                  Join the Collective
                </button>
              </form>
            </div>
          </div>

        </div>

        <div className="pt-12 border-t border-white/10 flex flex-col lg:flex-row justify-between items-center gap-8">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-[10px] font-bold uppercase tracking-[0.2em] text-cream-dark/40">
            <p>&copy; {new Date().getFullYear()} BrewAtlas Roasters</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-cream transition-colors">Privacy</a>
              <a href="#" className="hover:text-cream transition-colors">Terms</a>
              <a href="#" className="hover:text-cream transition-colors">Accessibility</a>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <span className="text-[10px] font-bold tracking-[0.12em] text-cream-dark/50" style={{ textTransform: 'none' }}>Made by <a href="https://diglab.ai/" target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">DigLab.ai</a> and <a href="https://linglinkai.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-cream transition-colors">LingLinkAI.cn</a></span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;